<template>
  <div id="pageTable" class="subView">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex lg12>
          <v-card>
            <v-toolbar dark color="primary" flat dense cad>
              <v-btn icon @click="$router.go(-1)">
                <v-icon>keyboard_arrow_left</v-icon>
              </v-btn>
              <v-toolbar-title class="subheading">승객 상세 정보</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-list three-line subheader>
              <v-data-table
                :headers="detailComplex.headers"
                :items="detailComplex.items"
                :rows-per-page-items="[1]"
                class="elevation-1"
                item-key="id"
                >
                <template slot="items" slot-scope="props">            
                  <td class="text-sm-center">{{ props.item.id }}</td>
                  <td class="text-sm-center">{{ props.item.name }}</td>
                  <td class="text-sm-center">{{ props.item.birthDay }}</td>
                  <td class="text-sm-center">{{ props.item.gender === 'M' ? '남자' : '여자' }}</td>
                  <td class="text-sm-center">{{ props.item.phoneNumber }}</td>
                  <td class="text-sm-center">{{ props.item.regDate }}</td>
                  <td class="text-sm-center">{{ props.item.state }}</td>
                  <td class="text-sm-center">{{ props.item.usageCount }}</td>
                  <td class="text-sm-center">{{ props.item.totalFee }}</td>
                  <td class="text-sm-center">{{ availablePoint }}</td>
                  <td class="text-sm-center">{{ props.item.deleteDate }}</td>
                </template>
              </v-data-table>
            </v-list>

            <v-list three-line subheader>
              <v-toolbar color="primary" dark flat dense cad>
                <v-toolbar-title class="subheading">이용 이력 (탑승 이력 및 결제 내역)</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-data-table
                :headers="passengerUsagesComplex.headers"
                :items="passengerUsagesComplex.items"
                :pagination.sync="passengerUsagesComplex.pagination"
                :rows-per-page-items="[5,{text:'All','value':-1}]"
                class="elevation-1"
                item-key="id"
                >
                <template slot="items" slot-scope="props">
                  <td class="text-sm-center"><a @click="openUsageDetail(props.item.id)">{{ props.item.id }}</a></td>
                  <td class="text-sm-center">{{ props.item.regDate }}</td>
                  <td class="text-sm-center">{{ props.item.startLocationName }}</td>
                  <td class="text-sm-center">{{ props.item.endLocationName }}</td>
                  <td class="text-sm-center">{{ props.item.carNum + ' ' + props.item.carModelName + ' / ' + props.item.driverName }}</td>
                  <td class="text-sm-center">{{ props.item.callOption }}</td>
                  <td class="text-sm-center">{{(props.item.totalTaxiFee + props.item.extraFee + props.item.serviceFee) - props.item.shareDiscount - props.item.couponDiscount}} 원</td>
                  <td class="text-sm-center" @click="openBillingHistoryDialog(props.item.billingHistoryId)"><a>{{ props.item.billingHistoryId == '0' ? '-' : props.item.billingHistoryId }}</a></td>
                  <td class="text-sm-center" @click="openCouponHistoryDialog(props.item.couponHistoryId)"><a>{{ props.item.couponHistoryId == '0' ? '-' : props.item.couponHistoryId }}</a></td>
                </template>
              </v-data-table>

              <v-dialog v-model="billingHistory.dialog" max-width="600px">
                <v-card>
                  <v-card-title>
                    <span class="headline">결제 이력 조회</span>
                  </v-card-title>
                  <v-divider></v-divider>
                  <v-card-text>
                    <v-container grid-list-md>
                      <v-layout wrap>
                        <v-flex xs12 sm4>
                          <v-text-field
                            label="결제이력고유번호"
                            v-model="detailBillingHistory.id"
                            disabled></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm4>
                          <v-text-field 
                            label="승객 고유번호"
                            v-model="detailBillingHistory.userId"
                            disabled></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm4>
                          <v-text-field 
                            v-model="detailBillingHistory.userName"
                            label="승객이름"
                            disabled></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm4>
                          <v-text-field
                            label="카드 승인번호"
                            v-model="detailBillingHistory.cardAuthNo"
                            disabled></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm4>
                          <v-text-field
                            label="카드이름"
                            v-model="detailBillingHistory.cardName"
                            disabled></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm4>
                          <v-text-field
                            label="결제금액"
                            v-model="detailBillingHistory.amount"
                            disabled></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm8>
                          <v-text-field
                            label="트랜잭션 번호"
                            v-model="detailBillingHistory.transactionId"
                            disabled></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm4>
                          <v-text-field
                            label="결제 상태"
                            v-model="detailBillingHistory.state"
                            disabled></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm4>
                          <v-text-field
                            label="결제일시"
                            v-model="detailBillingHistory.regDate"
                            disabled></v-text-field>
                        </v-flex>
                        <v-flex xs6 sm4>
                          <v-text-field
                            label="취소일시"
                            v-model="detailBillingHistory.canceledDate"
                            disabled></v-text-field>
                        </v-flex>
                        <v-flex xs6 sm4>
                          <v-text-field
                            label="결제실패일시"
                            v-model="detailBillingHistory.failedDate"
                            disabled></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer>
                    </v-spacer>
                    <v-btn color="blue darken-1" flat @click.native="billingHistory.dialog = false">Close</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>

              <v-dialog v-model="couponHistory.dialog" max-width="500px">
                <v-card>
                  <v-card-title>
                    <span class="headline">쿠폰 이력 조회</span>
                  </v-card-title>
                  <v-divider></v-divider>
                  <v-card-text>
                    <v-container grid-list-md>
                      <v-layout wrap>
                        <v-flex xs12 sm3>
                          <v-text-field
                            label="발급 번호"
                            v-model="detailCouponHistory.id"
                            disabled></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm4>
                          <v-text-field 
                            label="쿠폰 제목"
                            v-model="detailCouponHistory.title"
                            disabled></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm5>
                          <v-text-field 
                            v-model="detailCouponHistory.couponType"
                            label="쿠폰 유형"
                            disabled></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field
                            label="쿠폰 설명"
                            v-model="detailCouponHistory.description"
                            disabled></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6>
                          <v-text-field
                            label="발급대상"
                            v-model="detailCouponHistory.userId"
                            disabled></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6>
                          <v-text-field
                            label="쿠폰 금액"
                            v-model="detailCouponHistory.amount"
                            disabled></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm4>
                          <v-text-field
                            label="등록일시"
                            v-model="detailCouponHistory.regDate"
                            disabled></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm4>
                          <v-text-field
                            label="만료일시"
                            v-model="detailCouponHistory.expDate"
                            disabled></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm4>
                          <v-text-field
                            label="사용일시"
                            v-model="detailCouponHistory.usedDate"
                            disabled></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer>
                    </v-spacer>
                    <v-btn color="blue darken-1" flat @click.native="couponHistory.dialog = false">Close</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-list>
            <v-list three-line subheader>
              <v-toolbar color="primary" dark flat dense cad>
                <v-toolbar-title class="subheading">피신고 이력</v-toolbar-title>
                <v-spacer></v-spacer>
                <div>
                  누적 신고 횟수 : {{ totalBlameCount }}
                </div>
              </v-toolbar>
              <v-data-table
                :headers="blamesComplex.headers"
                :items="blamesComplex.items"
                :pagination.sync="blamesComplex.pagination"
                :rows-per-page-items="[5,{text:'All','value':-1}]"
                class="elevation-1"
                >
                <template slot="items" slot-scope="props">            
                  <td class="text-sm-center">{{ props.item.regDate }}</td>
                  <td class="text-sm-center">
                    <template v-if="props.item.relation.split('_')[0] === 'A'">
                      <a>관리자</a>
                    </template>
                    <template v-else>
                      <a @click="openReportDetail(props.item.relation, props.item.reportUserId)">{{ (props.item.relation.split("_")[0] === 'D' ? '기사' : '승객') + ' ' + props.item.reportUserId }}</a>
                    </template>
                  </td>
                  <td class="text-sm-center">{{ props.item.type }}</td>
                  <td class="text-sm-center">{{ changeReportStateText(props.item.state) }}</td>
                </template>
              </v-data-table>
            </v-list>
            
            <v-list three-line subheader>
              <v-toolbar color="primary" dark flat dense cad>
                <v-toolbar-title class="subheading">쿠폰 발급 이력</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-data-table
                :headers="couponHistoriesComplex.headers"
                :items="couponHistoriesComplex.items"
                :pagination.sync="couponHistoriesComplex.pagination"
                :rows-per-page-items="[5,{text:'All','value':-1}]"
                class="elevation-1"
                item-key="id"
                >
                <template slot="items" slot-scope="props">            
                  <td class="text-sm-center">{{ props.item.regDate }}</td>
                  <td class="text-sm-center">{{ props.item.expDate }}</td>
                  <td class="text-sm-center">{{ props.item.coupon.title }}</td>
                  <td class="text-sm-center">{{ props.item.coupon.couponType }}</td>
                  <td class="text-sm-center">{{ props.item.coupon.amount }}</td>
                  <td class="text-sm-center">{{ props.item.usedDate }}</td>
                </template>
              </v-data-table>
            </v-list>

            <v-list three-line subheader>
              <v-toolbar color="primary" dark flat dense cad>
                <v-toolbar-title class="subheading">포인트 이력</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-data-table
                      :headers="pointPassengersComplex.headers"
                      :items="pointPassengersComplex.items"
                      :pagination.sync="pointPassengersComplex.pagination"
                      :rows-per-page-items="[5,{text:'All','value':-1}]"
                      class="elevation-1"
                      item-key="id"
              >
                <template slot="items" slot-scope="props">
                  <td class="text-sm-center">{{ props.item.id }}</td>
                  <td class="text-sm-center">{{ props.item.pointType }}</td>
                  <td class="text-sm-center">{{ props.item.description }}</td>
                  <td class="text-sm-center">{{ props.item.points }}</td>
                  <td class="text-sm-center">{{ props.item.regDate }}</td>
                  <td class="text-sm-center">{{ props.item.usedDate }}</td>
                  <td class="text-sm-center">{{ props.item.expDate }}</td>
                </template>
              </v-data-table>
            </v-list>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import VWidget from '@/components/VWidget';
import State  from '@/api/state';
import PaymentState  from '@/api/paymentState';
import CouponType  from '@/api/couponType';

export default {
  components: {
    VWidget
  },
  data () {
    return {
      availablePoint: 0,
      detailComplex: {
        headers: [
          {
            text: '승객 회원 고유번호',
            value: 'id',
            sortable: false,
            align: 'center'
          },
          {
            text: '이름',
            value: 'name',
            sortable: false,
            align: 'center'
          },
          {
            text: '생년월일',
            value: 'birthDay',
            sortable: false,
            align: 'center'
          },
          {
            text: '성별',
            value: 'gender',
            sortable: false,
            align: 'center'
          },
          {
            text: '휴대전화번호',
            value: 'phoneNumber',
            sortable: false,
            align: 'center'
          },
          {
            text: '가입일',
            value: 'regDate',
            sortable: false,
            align: 'center'
          },
          {
            text: '사용 상태',
            value: 'state',
            sortable: false,
            align: 'center'
          },
          {
            text: '이용횟수',
            value: 'state',
            sortable: false,
            align: 'center'
          },
          {
            text: '총 이용 금액',
            value: 'state',
            sortable: false,
            align: 'center'
          },
          {
            text: '가용포인트',
            value: 'point',
            sortable: false,
            align: 'center'
          },
          {
            text: '탈퇴일',
            value: 'state',
            sortable: false,
            align: 'center'
          },
        ],
        items: []
      },
      passengerUsagesComplex: {
        pagination: {
          descending: true
        },
        headers: [
          {
            text: '고유번호',
            value: 'id',
            align: 'center'
          },
          {
            text: '날짜',
            value: 'regDate',
            align: 'center'
          },
          {
            text: '출발지',
            value: 'startLocationName',
            sortable: false,
            align: 'center'
          },
          {
            text: '도착지',
            value: 'endLocationName',
            sortable: false,
            align: 'center'
          },
          {
            text: '택시정보',
            value: 'carNum',
            sortable: false,
            align: 'center'
          },
          {
            text: '콜 종류',
            value: 'callOption',
            sortable: false,
            align: 'center'
          },
          {
            text: '최종 결제금액',
            value: 'totalFee',
            sortable: false,
            align: 'center'
          },
          {
            text: '결제이력',
            value: 'billingHistoryId',
            sortable: false,
            align: 'center'
          },
          {
            text: '쿠폰이력',
            value: 'couponHistoryId',
            sortable: false,
            align: 'center'
          },
        ],
        items: []
      },
      blamesComplex: {
        pagination: {
          descending: true
        },
        headers: [
          {
            text: '날짜',
            value: 'regDate',
            align: 'center'
          },
          {
            text: '신고자',
            value: 'reportUserId',
            sortable: false,
            align: 'center'
          },
          {
            text: '신고타입',
            value: 'type',
            sortable: false,
            align: 'center'
          },
          {
            text: '상태',
            value: 'state',
            sortable: false,
            align: 'center'
          },
        ],
        items: []
      },
      couponHistoriesComplex: {
        pagination: {
          descending: true
        },
        headers: [
          {
            text: '쿠폰 발급일',
            value: 'regDate',
            align: 'center'
          },
          {
            text: '쿠폰 만료일',
            value: 'expDate',
            align: 'center'
          },
          {
            text: '쿠폰명',
            value: 'title',
            sortable: false,
            align: 'center'
          },
          {
            text: '쿠폰 종류',
            value: 'couponType',
            sortable: false,
            align: 'center'
          },
          {
            text: '쿠폰 혜택',
            value: 'amount',
            sortable: false,
            align: 'center'
          },
          {
            text: '쿠폰 사용일',
            value: 'usedDate',
            sortable: false,
            align: 'center'
          },
        ],
        items: []
      },
      pointPassengersComplex: {
        pagination: {
          descending: true
        },
        headers: [
          {
            text: '고유번호',
            value: 'id',
            sortable: false,
            align: 'center'
          },
          {
            text: '타입',
            value: 'pointType',
            sortable: false,
            align: 'center'
          },
          {
            text: '내용',
            value: 'description',
            sortable: false,
            align: 'center'
          },
          {
            text: '금액',
            value: 'points',
            sortable: false,
            align: 'center'
          },
          {
            text: '등록일',
            value: 'regDate',
            sortable: false,
            align: 'center'
          },
          {
            text: '사용일',
            value: 'usedDate',
            sortable: false,
            align: 'center'
          },
          {
            text: '만료일',
            value: 'expDate',
            sortable: false,
            align: 'center'
          },
        ],
        items: []
      },
      state: State,
      totalBlameCount: 0,
      billingHistory: {
        dialog: false
      },
      couponHistory: {
        dialog: false
      },
      paymentState: PaymentState,
      couponType: CouponType,
      detailCouponHistory: {
        id: 1,
        title: 1,
        couponType: 1,
        description: 1,
        amount: 1,
        userId: 1,
        regDate: 1,
        expDate: 1,
        usedDate: 1
      },
      detailBillingHistory: {
        id: 1,
        userId: 1,
        userName: 1,
        amount: 1,
        cardName: 1,
        cardAuthNo: 1,
        transactionId: 1,
        state: 1,
        regDate: 1,
        canceledDate: 1,
        failedDate: 1
      },
    };
  },
  watch: {
    '$route.params' () {
      this.banbanCreated();
    }
  },
  mounted () {
    for (let i = 0; i < this.$parent.$children.length; i++) {
      if (this.$parent.$children[i].chkAutoReload != null) {
        this.$parent.$children[i].chkAutoReload();
      }
    }
    this.banbanCreated();
  },
  methods: {
    banbanCreated () {
      const prameters = {
        method: 'searchPassengerDetails',
        'id': this.$route.params.id
      };
      this.$store.dispatch('banbanAPI', prameters)
        .then(({ data }) => {
          console.log(data);
          this.callbackDetail(data);

          if (data.passenger != null) {
            this.detailComplex.items = [data.passenger];
          }

          this.availablePoint = data.availablePoint;
          this.passengerUsagesComplex.items = data.passengerUsages;
          this.blamesComplex.items = data.blames;
          this.couponHistoriesComplex.items = data.couponHistories;
          this.pointPassengersComplex.items = data.pointPassengers;

          top.getApp.progress.dialog = false;
        })
        .catch((error) => {
          if (top.getApp.commonError == null) {
            alert('알 수 없는 오류가 발생했습니다. 관리자에게 문의하세요.');
          }
          top.getApp.commonError = null;
          top.getApp.progress.dialog = false;
        });
    },
    callbackDetail (data) {
      /* 상세정보 세팅 */
      data.passenger.usageCount = data.passengerUsages.length;
      data.passenger.totalFee = 0;
      for (let i = 0; i < data.passengerUsages.length; i++) {
        data.passenger.totalFee += data.passengerUsages[i].serviceFee;
        data.passenger.totalFee += data.passengerUsages[i].taxiFee;
      }
      if (data.passenger.state === 'WITHDRAWAL') {
        data.passenger.deleteDate = data.passenger.modDate;
      } else {
        data.passenger.deleteDate = '-';
      }

      /* 계좌번호 세팅 */
      if (data.bankAccount != null) {
        data.bankAccount.name = data.passenger.name;
      }

      /* 피신고 세팅 */
      this.totalBlameCount = 0;
      for (let i = 0; i < data.blames.length; i++) {
        if (data.blames[i].state === 'APPROVED') {
          this.totalBlameCount += 1;
        }
      }
    },
    changeDetail (id) {
      this.$router.push('/member/passengerMemberDetail/' + id);
    },
    openReportDetail (relation, reportUserId) {
      if (relation.split('_')[0] === 'D') {
        this.$router.push('/member/driverMemberDetail/' + reportUserId);
      }
      else {
        this.$router.push('/member/passengerMemberDetail/' + reportUserId);
      }
    },
    openBillingHistoryDialog(billingHistoryId) {
      if(billingHistoryId != '0') {
        const prameters = {
          method: 'searchBillingHistoryDetail',
          'id': billingHistoryId
        };
        this.$store.dispatch('banbanAPI', prameters)
          .then(({ data }) => {
            this.detailBillingHistory.id = data.id;
            this.detailBillingHistory.userId = data.userId != null ? data.userId : '-';
            this.detailBillingHistory.userName = data.userName != null ? data.userName : '-';
            this.detailBillingHistory.amount = data.amount != null ? data.amount : '-';
            this.detailBillingHistory.cardName = data.cardName != null ? data.cardName : '-';
            this.detailBillingHistory.cardAuthNo = data.cardAuthNo != null ? data.cardAuthNo : '-';
            this.detailBillingHistory.transactionId = data.transactionId != null ? data.transactionId : '-';
            this.detailBillingHistory.state = this.changePaymentStateText(data.state);
            this.detailBillingHistory.regDate = data.regDate != null ? data.regDate : '-';
            this.detailBillingHistory.canceledDate = data.canceledDate != null ? data.canceledDate : '-';
            this.detailBillingHistory.failedDate = data.failedDate != null ? data.failedDate : '-';
            this.billingHistory.dialog = true;
            for (let i = this.$parent.$parent.$el.getElementsByClassName('v-input v-text-field v-input--is-label-active v-input--is-dirty v-input--is-disabled').length - 1; i >= 0; i--) {
              this.$parent.$parent.$el.getElementsByClassName('v-input v-text-field v-input--is-label-active v-input--is-dirty v-input--is-disabled')[i].className = 'v-input v-text-field v-input--is-label-active v-input--is-dirty';
            }
            top.getApp.progress.dialog = false;
          })
          .catch((error) => {
          if (top.getApp.commonError == null) {
            alert('알 수 없는 오류가 발생했습니다. 관리자에게 문의하세요.');
          }
          top.getApp.commonError = null;
            top.getApp.progress.dialog = false;
          });
      }
    },
    openCouponHistoryDialog(couponHistoryId) {
      if(couponHistoryId != '0') {
        const prameters = {
          method: 'searchCouponHistoryDetail',
          'id': couponHistoryId
        };
        this.$store.dispatch('banbanAPI', prameters)
          .then(({ data }) => {
            this.detailCouponHistory.id = data.id;
            this.detailCouponHistory.title = data.coupon.title;
            this.detailCouponHistory.couponType = this.changeCouponTypeText(data.coupon.couponType);
            this.detailCouponHistory.description = data.coupon.description;
            this.detailCouponHistory.amount = data.coupon.amount;
            this.detailCouponHistory.userId = data.userId;
            this.detailCouponHistory.regDate = data.regDate;
            this.detailCouponHistory.expDate = data.expDate;
            this.detailCouponHistory.usedDate = data.usedDate;
            this.couponHistory.dialog = true;
            for (let i = this.$parent.$parent.$el.getElementsByClassName('v-input v-text-field v-input--is-label-active v-input--is-dirty v-input--is-disabled').length - 1; i >= 0; i--) {
              this.$parent.$parent.$el.getElementsByClassName('v-input v-text-field v-input--is-label-active v-input--is-dirty v-input--is-disabled')[i].className = 'v-input v-text-field v-input--is-label-active v-input--is-dirty';
            }
            top.getApp.progress.dialog = false;
          })
          .catch((error) => {
          if (top.getApp.commonError == null) {
            alert('알 수 없는 오류가 발생했습니다. 관리자에게 문의하세요.');
          }
          top.getApp.commonError = null;
            top.getApp.progress.dialog = false;
          });
      }
    },
    changeCouponTypeText (couponType) {
      return top.getApp.changeCouponTypeText(couponType);
    },
    changePaymentStateText (stateCode) {
      return top.getApp.changePaymentStateText(stateCode);
    },
    changeReportStateText (reportState) {
      return top.getApp.changeReportStateText(reportState);
    },
    openUsageDetail (id) {
      this.$router.push('/usage/passengerUsageHistory/' + id);
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/member/PassengerMemberDetail.vue